<template>

    <div class="head">

        <div class="head_in">
            <div class="top_shop_left">
                <ul>
                    <li>您好，</li>
                    <li v-show="!isLogin"><router-link to="/user/login">登录</router-link></li>
                    <li v-show="!isLogin">|</li>
                    <li v-show="!isLogin"><router-link to="/user/register">注册</router-link></li>
                    <li v-show="isLogin"><router-link to="/user/index" style="color:#409EFF" title="个人中心" alt="个人中心">{{user_info.name}}</router-link></li>
                    <li v-show="isLogin">|</li>
                    <li v-show="isLogin"><router-link to="/user/index" >个人中心</router-link></li>
                    <li v-show="isLogin">|</li>
                    <li v-show="isLogin" @click="logout()">退出账号</li>
                </ul>
            </div>
            <div class="top_shop_right">
                <ul>
                    <li><router-link to="/" >首页</router-link></li>
                    <li>|</li>
                    <li v-show="isLogin"><router-link to="/user/order" >我的订单</router-link></li>
                    <li v-show="isLogin">|</li>
                    <!-- <li><a href="/dzfp/" target="_bank">电子发票</a></li>
                    <li>|</li> -->
                    <!-- <li><a href="http://www.sckxyy.net:888/product_repgoods" target="_bank">药检报告</a></li> -->
                    <li><a href="/down/" target="_bank">文件下载</a></li>
                    <!-- <li>|</li>
                    <li><a href="/zcpj/" target="_bank">注册批件</a></li>
                    <li>|</li>
                    <li><a href="/wts/" target="_bank">委托书</a></li> -->
                    <li>|</li>
                    <li><a style="color:#409EFF">服务热线：19130659157</a></li>
                    <li>|</li>
                    <li><a style="font-size:14px; font-weight:bold;color:#409EFF">售后热线：19130659157</a></li>
                    <li>|</li>
                    <li><a href="/admin/#/login/"  target="_bank">后台管理</a></li>
                   
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          isLogin:false,
          user_info:{},
          querySupplierHzid:null,
          companyId:null,
      };
    },
    watch: {},
    computed: {},
    methods: {
        logout:function(){
            this.$post(this.$api.homeLogout)
            this.$confirm('是否要退出当前账户?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(()=>{
                this.$message.success('退出成功');
                localStorage.removeItem('userInfo');
                localStorage.removeItem('token');
                this.$router.push('/user/login/');
            });
        },

        get_user_info:function(){
            this.$get(this.$api.homeGetUserInfo).then(res=>{
                if(res){
                    if(res.code==200){
                        this.isLogin = true;
                        this.user_info = res.data;
                        this.user_info.isLogin = true;
                        localStorage.setItem('userInfo',JSON.stringify(res.data));
                    }else if(res.code == 401){
                        localStorage.removeItem('userInfo');
                        localStorage.removeItem('token');
                        this.isLogin = false;
                    }else{
                        this.isLogin = false;
                    }
                }
            });
        },

        //跳转芸欣
        get_goBencao:function(){
            this.$get(this.$api.goBencao,{companyId:this.user_info.company}).then(res=>{
                if(res.data.code == 200){
                    this.companyId = res.data;
                }
            })
        }

    },
    created() {
        this.get_user_info();
        let user_info = localStorage.getItem('userInfo');
        if(!this.$isEmpty(user_info)){
            this.isLogin = true;
            this.user_info = JSON.parse(user_info);
            this.user_info.isLogin = true;
        }
    },
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
.head{
    border-bottom: 1px solid #efefef;
    background: #f9f9f9;
    font-size: 12px;
    line-height: 30px;
    .top-banner {
        width: 100%;
        height: 80px;
        margin: 0 auto;
        overflow: hidden;
    }
    .top-banner .module {
        width: 1200px;
        position: relative;
        margin: 0 auto;
        float: none;
    }

    .head_in{
        width: 1200px;
        margin:0 auto;
        height: 30px;
        line-height: 30px;;
        .top_shop_left{
            float: left;
            line-height: 30px;
            ul li{
                float: left;
                padding:0 5px;
                cursor: pointer;
            }
        }
        .top_shop_right{
            line-height: 30px;
            float: right;
            ul li{
                float: left;
                padding:0 5px;
            }
            li:hover{
                color:#409EFF;
            }
        }
    }
    .head_in:after{
        display: block;
        clear: both;
        content:'';
    }
    .head_in a:hover{
        color:#409EFF;
    }
}
</style>